var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-account-wrapper" },
    [
      !_vm.isDesktop
        ? [
            _c("div", { staticClass: "__title" }, [
              _vm._v(_vm._s(_vm.$t("regAcc")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "notice" }, [
              _vm._v(_vm._s(_vm.$t("startCreate.notice")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__btn_list" }, [
              _c(
                "div",
                { staticClass: "__btn __btn_all_in __pointer" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "download",
                    attrs: { icon: ["fab", "google-play"] }
                  }),
                  _vm._v("Google Play\n            ")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "__btn __btn_all_in __pointer" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "download",
                    attrs: { icon: ["fab", "app-store-ios"] }
                  }),
                  _vm._v("APP Store\n            ")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "__btn __btn_all_in __pointer",
                  attrs: { href: _vm.downloadUrl("win"), target: "_blank" }
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "download",
                    attrs: { icon: ["fab", "windows"] }
                  }),
                  _vm._v("Windows\n            ")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "__btn __btn_all_in __pointer",
                  attrs: { href: _vm.downloadUrl("mac"), target: "_blank" }
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "download",
                    attrs: { icon: ["fab", "apple"] }
                  }),
                  _vm._v("Mac\n            ")
                ],
                1
              )
            ])
          ]
        : _c("create-page"),
      _vm._v(" "),
      _c("div", { staticClass: "go-list clearfix" }, [
        _c(
          "span",
          {
            staticClass: "__pointer",
            on: {
              click: function($event) {
                return _vm.go("startLogin")
              }
            }
          },
          [
            _c("img", {
              staticClass: "back",
              attrs: { src: require("assets/imgs/arrow-back.svg") }
            }),
            _vm._v(_vm._s(_vm.$t("startCreate.goLogin")) + "\n        ")
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "__pointer",
            on: {
              click: function($event) {
                return _vm.go("tradeCenter")
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("startCreate.goDex")))]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }